import classes from "./BurgerMenu.module.css";

const BurgerMenu = props => {
  return <aside className={classes.burgerMenu}>{props.children}</aside>;
};

export default BurgerMenu;
